module.exports = __webpack_public_path__ + "static/08_NASA-c81eca98f49b8eea5f681d9e13c55f12.png";